export default __webpack_public_path__ + "static/grow-d2a58d6c6b8c7ed19a73e2dc7dafc0fa.webp";